import styled from "styled-components";
import { Radio } from "antd";
import { CustomSelect } from "./RegistrationFormStyle";

export const ClassTypeSelector = styled(Radio.Group)`
  height: 40px;
  display: flex;
  flex-direction: row;
  margin: 10px 0px;

  & .ant-radio-button-wrapper {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    color: #707070;
    padding: 0px 15px;
    font-size: 16px;
    min-width: 100px;
  }

  & .ant-radio-button-wrapper-checked {
    background-color: #1070b6;
    color: white;
  }
`;

export const CurrencySelector = styled(CustomSelect)`
  height: 40px;
`;
